function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60px",
    height: "60px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdcac9",
    d: "M 53.5,53.5 C 40.8333,53.5 28.1667,53.5 15.5,53.5C 15.5,42.8333 15.5,32.1667 15.5,21.5C 15.5,21.1667 15.5,20.8333 15.5,20.5C 20.5,20.5 25.5,20.5 30.5,20.5C 30.5,20.8333 30.5,21.1667 30.5,21.5C 25.8333,21.5 21.1667,21.5 16.5,21.5C 16.5,31.8333 16.5,42.1667 16.5,52.5C 28.1667,52.5 39.8333,52.5 51.5,52.5C 51.5,48.1667 51.5,43.8333 51.5,39.5C 51.6658,34.8215 51.4992,30.1548 51,25.5C 47.9177,23.375 44.7511,21.375 41.5,19.5C 44.3764,19.2433 47.043,20.2433 49.5,22.5C 50.3473,20.939 50.0139,19.439 48.5,18C 46.3225,16.7978 43.9892,16.2978 41.5,16.5C 41.6633,14.1432 41.4966,11.8098 41,9.5C 40.8227,13.3563 40.3227,17.023 39.5,20.5C 39.8168,16.2984 39.4834,12.2984 38.5,8.5C 35.5,8.5 32.5,8.5 29.5,8.5C 24.8333,8.5 20.1667,8.5 15.5,8.5C 12.3752,7.52056 9.04185,7.18723 5.5,7.5C 8.68934,6.83387 12.0227,6.1672 15.5,5.5C 15.7093,4.91395 16.0426,4.41395 16.5,4C 23.8333,3.33333 31.1667,3.33333 38.5,4C 44.2886,7.45466 49.122,11.9547 53,17.5C 53.4999,29.4954 53.6665,41.4954 53.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.047
    },
    fill: "#a96d6d",
    d: "M 5.5,7.5 C 5.5,10.8333 5.5,14.1667 5.5,17.5C 5.5,18.5 5.5,19.5 5.5,20.5C 8.83333,20.5 12.1667,20.5 15.5,20.5C 15.5,20.8333 15.5,21.1667 15.5,21.5C 11.8333,21.5 8.16667,21.5 4.5,21.5C 4.18054,16.6367 4.51388,11.97 5.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4100c",
    d: "M 5.5,7.5 C 9.04185,7.18723 12.3752,7.52056 15.5,8.5C 12.5,8.5 9.5,8.5 6.5,8.5C 6.24358,10.7925 6.57692,12.9592 7.5,15C 9.83073,14.8429 12.1641,14.3429 14.5,13.5C 14.238,14.9778 14.5713,16.3112 15.5,17.5C 18.9932,16.0623 19.9932,13.729 18.5,10.5C 19.1667,10.5 19.8333,10.5 20.5,10.5C 20.5,12.8333 20.5,15.1667 20.5,17.5C 24.5,18.1667 26.1667,16.5 25.5,12.5C 25.8333,12.5 26.1667,12.5 26.5,12.5C 26.2148,14.288 26.5481,15.9547 27.5,17.5C 28.2298,16.0663 29.2298,14.8996 30.5,14C 27.8333,13 27.8333,12 30.5,11C 29.552,10.5172 28.552,10.3505 27.5,10.5C 28.1667,9.83333 28.8333,9.16667 29.5,8.5C 32.5,8.5 35.5,8.5 38.5,8.5C 38.3841,11.8599 38.0508,15.1933 37.5,18.5C 28.1399,18.2478 18.8066,18.5811 9.5,19.5C 7.88565,19.1971 6.55232,18.5305 5.5,17.5C 5.5,14.1667 5.5,10.8333 5.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0c9c9",
    d: "M 20.5,10.5 C 22.698,10.1201 24.3646,10.7868 25.5,12.5C 26.1667,16.5 24.5,18.1667 20.5,17.5C 20.5,15.1667 20.5,12.8333 20.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ca5851",
    d: "M 21.5,12.5 C 22.5,12.5 23.5,12.5 24.5,12.5C 24.7778,14.3464 24.1112,15.6798 22.5,16.5C 21.5713,15.3112 21.238,13.9778 21.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#db0605",
    d: "M 15.5,8.5 C 20.1667,8.5 24.8333,8.5 29.5,8.5C 28.8333,9.16667 28.1667,9.83333 27.5,10.5C 26.6618,10.8417 26.3284,11.5084 26.5,12.5C 26.1667,12.5 25.8333,12.5 25.5,12.5C 24.3646,10.7868 22.698,10.1201 20.5,10.5C 19.8333,10.5 19.1667,10.5 18.5,10.5C 17.1667,10.5 15.8333,10.5 14.5,10.5C 14.5,11.5 14.5,12.5 14.5,13.5C 12.1641,14.3429 9.83073,14.8429 7.5,15C 6.57692,12.9592 6.24358,10.7925 6.5,8.5C 9.5,8.5 12.5,8.5 15.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0b1b0",
    d: "M 18.5,10.5 C 19.9932,13.729 18.9932,16.0623 15.5,17.5C 14.5713,16.3112 14.238,14.9778 14.5,13.5C 14.5,12.5 14.5,11.5 14.5,10.5C 15.8333,10.5 17.1667,10.5 18.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e4b2b2",
    d: "M 27.5,10.5 C 28.552,10.3505 29.552,10.5172 30.5,11C 27.8333,12 27.8333,13 30.5,14C 29.2298,14.8996 28.2298,16.0663 27.5,17.5C 26.5481,15.9547 26.2148,14.288 26.5,12.5C 26.3284,11.5084 26.6618,10.8417 27.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7a1512",
    d: "M 38.5,8.5 C 39.4834,12.2984 39.8168,16.2984 39.5,20.5C 37.8333,20.5 36.1667,20.5 34.5,20.5C 33.1667,20.5 31.8333,20.5 30.5,20.5C 25.5,20.5 20.5,20.5 15.5,20.5C 12.1667,20.5 8.83333,20.5 5.5,20.5C 5.5,19.5 5.5,18.5 5.5,17.5C 6.55232,18.5305 7.88565,19.1971 9.5,19.5C 18.8066,18.5811 28.1399,18.2478 37.5,18.5C 38.0508,15.1933 38.3841,11.8599 38.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9e5e4",
    d: "M 51.5,39.5 C 50.7784,39.0825 50.2784,38.4158 50,37.5C 49.7996,39.3197 48.9663,40.653 47.5,41.5C 46.7703,39.955 45.437,39.1216 43.5,39C 45.1667,38.6667 46.8333,38.3333 48.5,38C 45.3117,36.6842 41.9783,36.1842 38.5,36.5C 34.4327,33.6392 32.4327,29.6392 32.5,24.5C 32.558,22.3812 33.2247,21.0478 34.5,20.5C 36.1667,20.5 37.8333,20.5 39.5,20.5C 40.3227,17.023 40.8227,13.3563 41,9.5C 41.4966,11.8098 41.6633,14.1432 41.5,16.5C 43.9892,16.2978 46.3225,16.7978 48.5,18C 50.0139,19.439 50.3473,20.939 49.5,22.5C 47.043,20.2433 44.3764,19.2433 41.5,19.5C 44.7511,21.375 47.9177,23.375 51,25.5C 51.4992,30.1548 51.6658,34.8215 51.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f65a49",
    d: "M 30.5,20.5 C 31.8333,20.5 33.1667,20.5 34.5,20.5C 33.2247,21.0478 32.558,22.3812 32.5,24.5C 32.4327,29.6392 34.4327,33.6392 38.5,36.5C 39.7175,37.1614 41.0508,37.8281 42.5,38.5C 42.3764,39.1067 42.0431,39.44 41.5,39.5C 41.1667,39.5 40.8333,39.5 40.5,39.5C 39.4324,38.5655 38.099,38.2322 36.5,38.5C 35.6091,36.3911 34.4424,34.3911 33,32.5C 31.8201,34.8599 30.6534,37.1932 29.5,39.5C 29.1667,40.1667 28.8333,40.8333 28.5,41.5C 27.217,43.8682 25.5503,46.0349 23.5,48C 18.6134,47.9617 18.28,46.4617 22.5,43.5C 22.9382,43.4346 23.2716,43.6012 23.5,44C 21.9926,44.8373 21.4926,46.0039 22,47.5C 24.1019,45.9052 25.6019,43.9052 26.5,41.5C 27.7729,39.2872 28.7729,36.9538 29.5,34.5C 30.8976,33.2233 31.5643,31.5566 31.5,29.5C 30.9049,26.8599 30.5715,24.1933 30.5,21.5C 30.5,21.1667 30.5,20.8333 30.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfafa",
    d: "M 29.5,34.5 C 28.7729,36.9538 27.7729,39.2872 26.5,41.5C 24.847,41.6596 23.5137,42.3263 22.5,43.5C 18.28,46.4617 18.6134,47.9617 23.5,48C 25.5503,46.0349 27.217,43.8682 28.5,41.5C 30.1172,40.962 31.7839,40.6287 33.5,40.5C 38.2576,44.2764 43.9243,47.7764 50.5,51C 39.505,51.4998 28.505,51.6665 17.5,51.5C 17.3336,43.16 17.5003,34.8267 18,26.5C 22.2282,28.8418 26.0615,31.5085 29.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6e4e2",
    d: "M 36.5,38.5 C 34.0971,38.448 31.7638,38.7814 29.5,39.5C 30.6534,37.1932 31.8201,34.8599 33,32.5C 34.4424,34.3911 35.6091,36.3911 36.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5877c",
    d: "M 38.5,36.5 C 41.9783,36.1842 45.3117,36.6842 48.5,38C 46.8333,38.3333 45.1667,38.6667 43.5,39C 45.437,39.1216 46.7703,39.955 47.5,41.5C 45.1016,41.7406 43.1016,41.0739 41.5,39.5C 42.0431,39.44 42.3764,39.1067 42.5,38.5C 41.0508,37.8281 39.7175,37.1614 38.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f2f2",
    d: "M 30.5,21.5 C 30.5715,24.1933 30.9049,26.8599 31.5,29.5C 31.5643,31.5566 30.8976,33.2233 29.5,34.5C 26.0615,31.5085 22.2282,28.8418 18,26.5C 17.5003,34.8267 17.3336,43.16 17.5,51.5C 28.505,51.6665 39.505,51.4998 50.5,51C 43.9243,47.7764 38.2576,44.2764 33.5,40.5C 35.6074,39.5318 37.9407,39.1984 40.5,39.5C 40.8333,39.5 41.1667,39.5 41.5,39.5C 43.1016,41.0739 45.1016,41.7406 47.5,41.5C 48.9663,40.653 49.7996,39.3197 50,37.5C 50.2784,38.4158 50.7784,39.0825 51.5,39.5C 51.5,43.8333 51.5,48.1667 51.5,52.5C 39.8333,52.5 28.1667,52.5 16.5,52.5C 16.5,42.1667 16.5,31.8333 16.5,21.5C 21.1667,21.5 25.8333,21.5 30.5,21.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9988e",
    d: "M 36.5,38.5 C 38.099,38.2322 39.4324,38.5655 40.5,39.5C 37.9407,39.1984 35.6074,39.5318 33.5,40.5C 31.7839,40.6287 30.1172,40.962 28.5,41.5C 28.8333,40.8333 29.1667,40.1667 29.5,39.5C 31.7638,38.7814 34.0971,38.448 36.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcb3ad",
    d: "M 26.5,41.5 C 25.6019,43.9052 24.1019,45.9052 22,47.5C 21.4926,46.0039 21.9926,44.8373 23.5,44C 23.2716,43.6012 22.9382,43.4346 22.5,43.5C 23.5137,42.3263 24.847,41.6596 26.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#1d1d1d",
    d: "M 15.5,53.5 C 28.1667,53.5 40.8333,53.5 53.5,53.5C 53.3893,54.1174 53.056,54.6174 52.5,55C 40.5,55.6667 28.5,55.6667 16.5,55C 15.944,54.6174 15.6107,54.1174 15.5,53.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.9c345399e15f934bd60074732fc22e5e.svg";
export { ForwardRef as ReactComponent };